import React from 'react'
import Link from 'gatsby-link'
import Navigoat from '../layouts/navigoat.js'
import ProjectPage from '../layouts/pr_page.js'

export default () =>
  <div>
    <Navigoat active_tab='projs'/>
    <ProjectPage title = 'FACETS'
                 paper_title = 'FACETS: Adaptive Local Exploration of Large Graphs'
                authors = 'Robert Pienta, Minsuk Kahng, Zhiyuan Lin, Jilles Vreeken, Partha Talukdar, James Abello, Ganesj Parameswaran, and Duen Horng Chau'
                 abstract = 'Visualization is a powerful paradigm for exploratory data analysis. Visualizing large graphs, however, often results in excessive edges crossings and overlapping nodes. We propose a new scalable approach called FACETS that helps users adaptively explore large million-node graphs from a local perspective, guiding them to focus on nodes and neighborhoods that are most subjectively interesting to users. We contribute novel ideas to measure this interestingness in terms of how surprising a neighborhood is given the background distribution, as well as how well it matches what the user has chosen to explore. FACETS uses Jensen-Shannon divergence over information-theoretically optimized histograms to calculate the subjective user interest and surprise scores. Participants in a user study found FACETS easy to use, easy to learn, and exciting to use. Empirical runtime analyses demonstrated FACETS’s practical scalability on large real-world graphs with up to 5 million edges, returning results in fewer than 1.5 seconds.'
                 paper_linky = '../data/17-sdm-facets-mage.pdf'
                 paper_img = '../imgs/projs/pr-facets-cj.png'
                 img_caption = ''
                 video_linky = ''
                 bibtex = {`@inproceedings{pienta2017facets,
                 title={FACETS: Adaptive Local Exploration of Large Graphs},
                 author={Pienta, Robert and Kahng, Minsuk and Lin, Zhiyuan and Vreeken, Jilles and Talukdar, Partha and Abello, James and Parameswaran, Ganesh and Chau, Duen Horng},
                 booktitle={Proceedings of the 2017 SIAM International Conference on Data Mining},
                 pages={597--605},
                 year={2017},
                 organization={SIAM}
               }`}
    />

  </div>



// WEBPACK FOOTER //
// ./src/pages/pr_facets.js